import { useEffect, useState } from 'react';
import { Image } from '../Image/Image';
import styles from './Hero.module.scss';
import cn from 'classnames';
import { Spinner } from '../Spinner/Spinner';
export const Hero = ({content})=>{
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(()=>{
    if(!content && !content.heroBackground){
      setIsLoaded(true);
      return;
    }
    const timer = setTimeout(() => setIsLoaded(true), 5000);

    return () => clearTimeout(timer); 
  },[content])
  if(!content){
    return;
  }
  const { title, subtitle,heroBackground } = content;
  return (
    <div className={styles.hero} >
      {!isLoaded && <Spinner/>}
      {heroBackground && <Image src={heroBackground} onLoad={() => setIsLoaded(true)} className={styles.background}/>}
      <div className={styles.content}>
        {title && <div className={styles.title} dangerouslySetInnerHTML={{ __html:title }}/>}
        {subtitle && <div className={cn(styles.subtitle)} dangerouslySetInnerHTML={{ __html:subtitle }}/>}
      </div>
    </div>
  )
}